/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Onbilgi_S12_Li2Inputs */

const tr_onbilgi_s12_li2 = /** @type {(inputs: Onbilgi_S12_Li2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Form, Müşterinin e-posta adresine kalıcı veri saklayıcı sıfatıyla iletilir ve Platform üzerinden her zaman erişilebilir tutulur.`)
};

const en_onbilgi_s12_li2 = /** @type {(inputs: Onbilgi_S12_Li2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The form is delivered to the Customer's email address in the capacity of a durable medium and is kept accessible at all times through the Platform.`)
};

const de_onbilgi_s12_li2 = /** @type {(inputs: Onbilgi_S12_Li2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Das Formular wird in der Eigenschaft eines dauerhaften Datenträgers an die E-Mail-Adresse des Kunden übermittelt und über die Plattform jederzeit zugänglich gehalten.`)
};

const ru_onbilgi_s12_li2 = /** @type {(inputs: Onbilgi_S12_Li2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Форма направляется на адрес электронной почты Клиента в качестве постоянного носителя данных и постоянно доступна на Платформе.`)
};

/**
* | output |
* | --- |
* | "The form is delivered to the Customer's email address in the capacity of a durable medium and is kept accessible at all times through the Platform." |
*
* @param {Onbilgi_S12_Li2Inputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const onbilgi_s12_li2 = /** @type {((inputs?: Onbilgi_S12_Li2Inputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Onbilgi_S12_Li2Inputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_onbilgi_s12_li2(inputs)
	if (locale === "de") return de_onbilgi_s12_li2(inputs)
	if (locale === "ru") return ru_onbilgi_s12_li2(inputs)
	return tr_onbilgi_s12_li2(inputs)
});